
  //DOG MOM
(() => { 
  // ✅ 해당 상품 페이지만
  if (!location.pathname.includes("/products/dog-mom-design-embroidered-cap")) return;
  
  const TO_COUNT = "92";
  const TARGET_PCTS = ["82%", "8%", "10%", "0%", "0%"]; // 5★ → 1★

  /* 1) 단독 숫자 11 -> 14 */
  function force10to17() {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const t = node.nodeValue;
      if (!t) continue;
      const replaced = t.replace(/(^|\D)18(\D|$)/g, `$1${TO_COUNT}$2`);
      if (replaced !== t) node.nodeValue = replaced;
    }
  }

  /* 2) 화면에 보이는 퍼센트 leaf 수집 */
  function getVisiblePercentLeafs() {
    return Array.from(document.querySelectorAll("*"))
      .filter(el => el.childElementCount === 0)
      .filter(el => el.offsetParent !== null)
      .filter(el => {
        const tx = (el.textContent || "").trim();
        return /^\d{1,3}%+$/.test(tx);
      })
      .map(el => {
        const r = el.getBoundingClientRect();
        return { el, top: r.top, left: r.left, right: r.right };
      });
  }

  /* 3) 오른쪽 정렬된 5줄 퍼센트 그룹 찾기 */
  function pickBestFiveRowPercentGroup(items) {
    if (items.length < 5) return null;

    const bins = new Map();
    for (const it of items) {
      const key = Math.round(it.right / 10) * 10;
      if (!bins.has(key)) bins.set(key, []);
      bins.get(key).push(it);
    }

    let best = null;

    for (const arr of bins.values()) {
      arr.sort((a, b) => a.top - b.top);

      for (let i = 0; i <= arr.length - 5; i++) {
        const slice = arr.slice(i, i + 5);

        const gaps = [];
        for (let j = 0; j < 4; j++) gaps.push(slice[j + 1].top - slice[j].top);

        const maxGap = Math.max(...gaps);
        const minGap = Math.min(...gaps);

        if (maxGap > 140 || minGap < 8) continue;

        const score = maxGap - minGap;
        if (!best || score < best.score) best = { score, slice };
      }
    }

    return best ? best.slice.map(x => x.el) : null;
  }

  /* 4) 같은 줄에서 "%만 있는 노드" 제거해서 %% 방지 */
  function removeExtraPercentSignsForRow(percentEl) {
    const row = percentEl.closest("div, li, tr") || percentEl.parentElement;
    if (!row) return;

    row.querySelectorAll("*").forEach(el => {
      if (el === percentEl) return;
      if (el.childElementCount !== 0) return;

      const tx = (el.textContent || "").trim();
      if (tx === "%" || tx === "%%") el.textContent = "";
    });

    row.childNodes.forEach(n => {
      if (n.nodeType === Node.TEXT_NODE) {
        const tx = (n.nodeValue || "").trim();
        if (tx === "%" || tx === "%%") n.nodeValue = "";
      }
    });
  }

  /* ✅ 추가: row 안의 "검정 바" width를 퍼센트와 동일하게 맞추기 */
  function syncBarWidthForRow(percentEl, pctNum) {
    const row = percentEl.closest("div, li, tr") || percentEl.parentElement;
    if (!row) return;

    // row 안에서 "가로 막대(회색 배경)" + "검정 채움" 구조를 찾음
    const divs = Array.from(row.querySelectorAll("div"));
    if (divs.length < 2) return;

    function luminance(rgb) {
      const m = rgb.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
      if (!m) return null;
      const r = +m[1], g = +m[2], b = +m[3];
      return (0.2126*r + 0.7152*g + 0.0722*b) / 255;
    }

    let fill = null;

    // 1) "밝은(회색) 바" 안에 "어두운(검정) 바"가 들어있는 패턴 우선 탐색
    for (const outer of divs) {
      const os = getComputedStyle(outer);
      const ol = luminance(os.backgroundColor);
      if (ol === null) continue;

      // 회색/밝은 배경(대략) + 가로 형태
      const oh = parseFloat(os.height || "0");
      if (!(ol > 0.6 && oh >= 4 && oh <= 30)) continue;

      const children = Array.from(outer.children || []).filter(c => c.tagName === "DIV");
      for (const inner of children) {
        const is = getComputedStyle(inner);
        const il = luminance(is.backgroundColor);
        const ih = parseFloat(is.height || "0");
        if (il === null) continue;

        // 검정/어두운 채움(대략)
        if (il < 0.35 && ih >= 4 && ih <= 30) {
          fill = inner;
          break;
        }
      }
      if (fill) break;
    }

    // 2) fallback: row 안의 "어두운 작은 가로 div" 중 하나를 fill로
    if (!fill) {
      const candidates = divs.filter(d => {
        const s = getComputedStyle(d);
        const l = luminance(s.backgroundColor);
        if (l === null) return false;
        const h = parseFloat(s.height || "0");
        return l < 0.35 && h >= 4 && h <= 30;
      });
      fill = candidates[0] || null;
    }

    if (!fill) return;

    // width 강제
    fill.style.width = pctNum + "%";
    fill.style.maxWidth = "100%";

    // aria 속성 있으면 같이 맞춤
    if (fill.hasAttribute("aria-valuenow")) fill.setAttribute("aria-valuenow", String(pctNum));
    if (fill.hasAttribute("aria-valuemax")) fill.setAttribute("aria-valuemax", "100");
  }

  /* 5) 퍼센트 강제 적용 + 검정 바 동기화 */
  function forcePercents() {
    const items = getVisiblePercentLeafs();
    const group = pickBestFiveRowPercentGroup(items);
    if (!group || group.length < 5) return;

    group.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);

    for (let i = 0; i < 5; i++) {
      group[i].textContent = TARGET_PCTS[i];
      group[i].textContent = (group[i].textContent || "").replace(/%{2,}/g, "%");
      removeExtraPercentSignsForRow(group[i]);

      const pctNum = parseInt(TARGET_PCTS[i], 10);
      if (!Number.isNaN(pctNum)) syncBarWidthForRow(group[i], pctNum);
    }
  }

  function applyAll() {
    force10to17();
    forcePercents();
  }

  applyAll();
  setInterval(applyAll, 400);

  let t = null;
  new MutationObserver(() => {
    clearTimeout(t);
    t = setTimeout(applyAll, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyAll);
  }
  window.addEventListener("load", applyAll);
})();


//PT404
(() => { 
  // ✅ 해당 상품 페이지만
  if (!location.pathname.includes("/products/metallic-vinyl-with-black-fur-trapper-hat")) return;
  
  const TO_COUNT = "50";
  const TARGET_PCTS = ["80%", "6%", "7%", "0%", "7%"]; // 5★ → 1★

  /* 1) 단독 숫자 11 -> 14 */
  function force10to17() {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const t = node.nodeValue;
      if (!t) continue;
      const replaced = t.replace(/(^|\D)32(\D|$)/g, `$1${TO_COUNT}$2`);
      if (replaced !== t) node.nodeValue = replaced;
    }
  }

  /* 2) 화면에 보이는 퍼센트 leaf 수집 */
  function getVisiblePercentLeafs() {
    return Array.from(document.querySelectorAll("*"))
      .filter(el => el.childElementCount === 0)
      .filter(el => el.offsetParent !== null)
      .filter(el => {
        const tx = (el.textContent || "").trim();
        return /^\d{1,3}%+$/.test(tx);
      })
      .map(el => {
        const r = el.getBoundingClientRect();
        return { el, top: r.top, left: r.left, right: r.right };
      });
  }

  /* 3) 오른쪽 정렬된 5줄 퍼센트 그룹 찾기 */
  function pickBestFiveRowPercentGroup(items) {
    if (items.length < 5) return null;

    const bins = new Map();
    for (const it of items) {
      const key = Math.round(it.right / 10) * 10;
      if (!bins.has(key)) bins.set(key, []);
      bins.get(key).push(it);
    }

    let best = null;

    for (const arr of bins.values()) {
      arr.sort((a, b) => a.top - b.top);

      for (let i = 0; i <= arr.length - 5; i++) {
        const slice = arr.slice(i, i + 5);

        const gaps = [];
        for (let j = 0; j < 4; j++) gaps.push(slice[j + 1].top - slice[j].top);

        const maxGap = Math.max(...gaps);
        const minGap = Math.min(...gaps);

        if (maxGap > 140 || minGap < 8) continue;

        const score = maxGap - minGap;
        if (!best || score < best.score) best = { score, slice };
      }
    }

    return best ? best.slice.map(x => x.el) : null;
  }

  /* 4) 같은 줄에서 "%만 있는 노드" 제거해서 %% 방지 */
  function removeExtraPercentSignsForRow(percentEl) {
    const row = percentEl.closest("div, li, tr") || percentEl.parentElement;
    if (!row) return;

    row.querySelectorAll("*").forEach(el => {
      if (el === percentEl) return;
      if (el.childElementCount !== 0) return;

      const tx = (el.textContent || "").trim();
      if (tx === "%" || tx === "%%") el.textContent = "";
    });

    row.childNodes.forEach(n => {
      if (n.nodeType === Node.TEXT_NODE) {
        const tx = (n.nodeValue || "").trim();
        if (tx === "%" || tx === "%%") n.nodeValue = "";
      }
    });
  }

  /* ✅ 추가: row 안의 "검정 바" width를 퍼센트와 동일하게 맞추기 */
  function syncBarWidthForRow(percentEl, pctNum) {
    const row = percentEl.closest("div, li, tr") || percentEl.parentElement;
    if (!row) return;

    // row 안에서 "가로 막대(회색 배경)" + "검정 채움" 구조를 찾음
    const divs = Array.from(row.querySelectorAll("div"));
    if (divs.length < 2) return;

    function luminance(rgb) {
      const m = rgb.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
      if (!m) return null;
      const r = +m[1], g = +m[2], b = +m[3];
      return (0.2126*r + 0.7152*g + 0.0722*b) / 255;
    }

    let fill = null;

    // 1) "밝은(회색) 바" 안에 "어두운(검정) 바"가 들어있는 패턴 우선 탐색
    for (const outer of divs) {
      const os = getComputedStyle(outer);
      const ol = luminance(os.backgroundColor);
      if (ol === null) continue;

      // 회색/밝은 배경(대략) + 가로 형태
      const oh = parseFloat(os.height || "0");
      if (!(ol > 0.6 && oh >= 4 && oh <= 30)) continue;

      const children = Array.from(outer.children || []).filter(c => c.tagName === "DIV");
      for (const inner of children) {
        const is = getComputedStyle(inner);
        const il = luminance(is.backgroundColor);
        const ih = parseFloat(is.height || "0");
        if (il === null) continue;

        // 검정/어두운 채움(대략)
        if (il < 0.35 && ih >= 4 && ih <= 30) {
          fill = inner;
          break;
        }
      }
      if (fill) break;
    }

    // 2) fallback: row 안의 "어두운 작은 가로 div" 중 하나를 fill로
    if (!fill) {
      const candidates = divs.filter(d => {
        const s = getComputedStyle(d);
        const l = luminance(s.backgroundColor);
        if (l === null) return false;
        const h = parseFloat(s.height || "0");
        return l < 0.35 && h >= 4 && h <= 30;
      });
      fill = candidates[0] || null;
    }

    if (!fill) return;

    // width 강제
    fill.style.width = pctNum + "%";
    fill.style.maxWidth = "100%";

    // aria 속성 있으면 같이 맞춤
    if (fill.hasAttribute("aria-valuenow")) fill.setAttribute("aria-valuenow", String(pctNum));
    if (fill.hasAttribute("aria-valuemax")) fill.setAttribute("aria-valuemax", "100");
  }

  /* 5) 퍼센트 강제 적용 + 검정 바 동기화 */
  function forcePercents() {
    const items = getVisiblePercentLeafs();
    const group = pickBestFiveRowPercentGroup(items);
    if (!group || group.length < 5) return;

    group.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);

    for (let i = 0; i < 5; i++) {
      group[i].textContent = TARGET_PCTS[i];
      group[i].textContent = (group[i].textContent || "").replace(/%{2,}/g, "%");
      removeExtraPercentSignsForRow(group[i]);

      const pctNum = parseInt(TARGET_PCTS[i], 10);
      if (!Number.isNaN(pctNum)) syncBarWidthForRow(group[i], pctNum);
    }
  }

  function applyAll() {
    force10to17();
    forcePercents();
  }

  applyAll();
  setInterval(applyAll, 400);

  let t = null;
  new MutationObserver(() => {
    clearTimeout(t);
    t = setTimeout(applyAll, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyAll);
  }
  window.addEventListener("load", applyAll);
})();

//PT505
(() => { 
  // ✅ 해당 상품 페이지만
  if (!location.pathname.includes("/products/pu-leather-with-brown-fur-trapper-hat")) return;
  
  const TO_COUNT = "39";
  const TARGET_PCTS = ["71%", "29%", "0%", "0%", "0%"]; // 5★ → 1★

  /* 1) 단독 숫자 11 -> 14 */
  function force10to17() {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const t = node.nodeValue;
      if (!t) continue;
      const replaced = t.replace(/(^|\D)29(\D|$)/g, `$1${TO_COUNT}$2`);
      if (replaced !== t) node.nodeValue = replaced;
    }
  }

  /* 2) 화면에 보이는 퍼센트 leaf 수집 */
  function getVisiblePercentLeafs() {
    return Array.from(document.querySelectorAll("*"))
      .filter(el => el.childElementCount === 0)
      .filter(el => el.offsetParent !== null)
      .filter(el => {
        const tx = (el.textContent || "").trim();
        return /^\d{1,3}%+$/.test(tx);
      })
      .map(el => {
        const r = el.getBoundingClientRect();
        return { el, top: r.top, left: r.left, right: r.right };
      });
  }

  /* 3) 오른쪽 정렬된 5줄 퍼센트 그룹 찾기 */
  function pickBestFiveRowPercentGroup(items) {
    if (items.length < 5) return null;

    const bins = new Map();
    for (const it of items) {
      const key = Math.round(it.right / 10) * 10;
      if (!bins.has(key)) bins.set(key, []);
      bins.get(key).push(it);
    }

    let best = null;

    for (const arr of bins.values()) {
      arr.sort((a, b) => a.top - b.top);

      for (let i = 0; i <= arr.length - 5; i++) {
        const slice = arr.slice(i, i + 5);

        const gaps = [];
        for (let j = 0; j < 4; j++) gaps.push(slice[j + 1].top - slice[j].top);

        const maxGap = Math.max(...gaps);
        const minGap = Math.min(...gaps);

        if (maxGap > 140 || minGap < 8) continue;

        const score = maxGap - minGap;
        if (!best || score < best.score) best = { score, slice };
      }
    }

    return best ? best.slice.map(x => x.el) : null;
  }

  /* 4) 같은 줄에서 "%만 있는 노드" 제거해서 %% 방지 */
  function removeExtraPercentSignsForRow(percentEl) {
    const row = percentEl.closest("div, li, tr") || percentEl.parentElement;
    if (!row) return;

    row.querySelectorAll("*").forEach(el => {
      if (el === percentEl) return;
      if (el.childElementCount !== 0) return;

      const tx = (el.textContent || "").trim();
      if (tx === "%" || tx === "%%") el.textContent = "";
    });

    row.childNodes.forEach(n => {
      if (n.nodeType === Node.TEXT_NODE) {
        const tx = (n.nodeValue || "").trim();
        if (tx === "%" || tx === "%%") n.nodeValue = "";
      }
    });
  }

  /* ✅ 추가: row 안의 "검정 바" width를 퍼센트와 동일하게 맞추기 */
  function syncBarWidthForRow(percentEl, pctNum) {
    const row = percentEl.closest("div, li, tr") || percentEl.parentElement;
    if (!row) return;

    // row 안에서 "가로 막대(회색 배경)" + "검정 채움" 구조를 찾음
    const divs = Array.from(row.querySelectorAll("div"));
    if (divs.length < 2) return;

    function luminance(rgb) {
      const m = rgb.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
      if (!m) return null;
      const r = +m[1], g = +m[2], b = +m[3];
      return (0.2126*r + 0.7152*g + 0.0722*b) / 255;
    }

    let fill = null;

    // 1) "밝은(회색) 바" 안에 "어두운(검정) 바"가 들어있는 패턴 우선 탐색
    for (const outer of divs) {
      const os = getComputedStyle(outer);
      const ol = luminance(os.backgroundColor);
      if (ol === null) continue;

      // 회색/밝은 배경(대략) + 가로 형태
      const oh = parseFloat(os.height || "0");
      if (!(ol > 0.6 && oh >= 4 && oh <= 30)) continue;

      const children = Array.from(outer.children || []).filter(c => c.tagName === "DIV");
      for (const inner of children) {
        const is = getComputedStyle(inner);
        const il = luminance(is.backgroundColor);
        const ih = parseFloat(is.height || "0");
        if (il === null) continue;

        // 검정/어두운 채움(대략)
        if (il < 0.35 && ih >= 4 && ih <= 30) {
          fill = inner;
          break;
        }
      }
      if (fill) break;
    }

    // 2) fallback: row 안의 "어두운 작은 가로 div" 중 하나를 fill로
    if (!fill) {
      const candidates = divs.filter(d => {
        const s = getComputedStyle(d);
        const l = luminance(s.backgroundColor);
        if (l === null) return false;
        const h = parseFloat(s.height || "0");
        return l < 0.35 && h >= 4 && h <= 30;
      });
      fill = candidates[0] || null;
    }

    if (!fill) return;

    // width 강제
    fill.style.width = pctNum + "%";
    fill.style.maxWidth = "100%";

    // aria 속성 있으면 같이 맞춤
    if (fill.hasAttribute("aria-valuenow")) fill.setAttribute("aria-valuenow", String(pctNum));
    if (fill.hasAttribute("aria-valuemax")) fill.setAttribute("aria-valuemax", "100");
  }

  /* 5) 퍼센트 강제 적용 + 검정 바 동기화 */
  function forcePercents() {
    const items = getVisiblePercentLeafs();
    const group = pickBestFiveRowPercentGroup(items);
    if (!group || group.length < 5) return;

    group.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);

    for (let i = 0; i < 5; i++) {
      group[i].textContent = TARGET_PCTS[i];
      group[i].textContent = (group[i].textContent || "").replace(/%{2,}/g, "%");
      removeExtraPercentSignsForRow(group[i]);

      const pctNum = parseInt(TARGET_PCTS[i], 10);
      if (!Number.isNaN(pctNum)) syncBarWidthForRow(group[i], pctNum);
    }
  }

  function applyAll() {
    force10to17();
    forcePercents();
  }

  applyAll();
  setInterval(applyAll, 400);

  let t = null;
  new MutationObserver(() => {
    clearTimeout(t);
    t = setTimeout(applyAll, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyAll);
  }
  window.addEventListener("load", applyAll);
})();

  